import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'

const state = {
  quickLaunch: {
    init: 0,
    menu: {},
    apps: []
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
